/// <reference path='../_all.ts' />


module product_references {
  /**
   * Angular Service http://stackoverflow.com/questions/19447886/how-can-i-define-an-angularjs-service-using-a-typescript-class-that-doesnt-poll
   */
  export class ProductReferenceService {
    static $inject = [
      '$http',
      'CacheFactory', 
    ];

    constructor(
      // Add the parameter and type definition.
      public $http: ng.IHttpService,
      private CacheFactory: CacheFactory.ICacheFactory
    ) { } 

    public getReferences(re : IRouteEntry) : ng.IHttpPromise<ProductReferenceData> {

      var productFilter :IRouteParameter[] = re.RouteParameterStack.filter((param : IRouteParameter, i: number) : boolean => {
        return param.Placeholder === "ProductName"
      })

      //if (productFilter.length < 1) throw "Error, no product";

      return this.$http<ProductReferenceData>({
          method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/ProductReference/ByProduct/"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          "productId" :  productFilter[0] ? productFilter[0].Id : null
        }
        , data: re.RouteParameterStack
      }).then(
        (response : { data : ProductReferenceData}) :any => { 
        response.data.References.forEach((ref, i, arr) => {
          ref.ProductReferenceDate = new Date(<any>ref.ProductReferenceDate);//we recieve that as string, have to convert it.
        });
        response.data.showProductFilter = productFilter[0] ? false : true;
        return response;
      }); 

    }

    public getProducts(): ng.IHttpPromise<search.Product[]> {
      return this.$http<search.Product[]>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Product/GetAll"
        , headers: { 'Content-Type': 'application/json' }
        , params: {}
      }).then((response) => {
        return response;
      });
    }

  }
}